import { render, staticRenderFns } from "./PlanoPrecos.vue?vue&type=template&id=627e1bc3&scoped=true"
import script from "./PlanoPrecos.vue?vue&type=script&lang=js"
export * from "./PlanoPrecos.vue?vue&type=script&lang=js"
import style0 from "./PlanoPrecos.vue?vue&type=style&index=0&id=627e1bc3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e1bc3",
  null
  
)

export default component.exports